import { useEffect, useState } from "react";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Only set up the timer if we have a value
    if (value.trim()) {
      const timer = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(timer);
      };
    } else {
      // If value is empty, update immediately
      setDebouncedValue(value);
    }
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
